import { render, staticRenderFns } from "./FeaturedAlbumList.vue?vue&type=template&id=4ccf1e38&scoped=true&"
import script from "./FeaturedAlbumList.vue?vue&type=script&lang=js&"
export * from "./FeaturedAlbumList.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedAlbumList.vue?vue&type=style&index=0&id=4ccf1e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf1e38",
  null
  
)

export default component.exports